import { Button, Stack, Typography } from '@mui/material';
import { capitalize } from 'lodash';
import Image, { type StaticImageData } from 'next/image';
import NextLink from 'next/link';
import EmptySearchIcon from 'public/img/illustrations/magnifying-glass-and-document.svg';
import {
  TrackHomePageEvent,
  useTrackHomePageAnalytics,
} from '$analytics/useTrackAnalytics/domains/homePage';

export const EmptyState = () => {
  const buttons = ['listings', 'offers', 'leases'];
  const trackEvent = useTrackHomePageAnalytics();

  return (
    <Stack sx={{ color: 'text.primary', alignItems: 'center', pt: 4, gap: 1 }}>
      <Image alt="No Search Results" src={EmptySearchIcon as StaticImageData} />

      <Typography variant="subtitle1">No Transactions Found</Typography>
      <Typography variant="body2" sx={{ pb: 3.5, pt: 0.5 }}>
        Try updating your search term
      </Typography>

      <Stack
        direction="row"
        sx={{ pb: 3, gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}
      >
        {buttons.map((type) => (
          <Button
            key={type}
            id={`view-${type}-button`}
            LinkComponent={NextLink}
            href={`/${type}`}
            variant="outlined"
            onClick={() => {
              trackEvent(TrackHomePageEvent.SearchNoResultsViewAllClick, {
                eventTarget: `view_${type}_button`,
              });
            }}
          >{`View ${capitalize(type)}`}</Button>
        ))}
      </Stack>
    </Stack>
  );
};
